import React from "react";
import Main from "../pages/Main";
import AppBreadcrumbs from "./ui/AppBreadcrumbs";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import PrintRoundedIcon from "@mui/icons-material/PrintRounded";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import BrandLogo from "../utils/logoImg";
import { useBranding } from "../context/BrandingContext";

const Certificate = () => {
  const { userInfo } = useSelector((state) => state?.auth);
  const navigate = useNavigate();
  const { settings, mediaUrl, companyName, formatDate } = useBranding();

  const certLogo = settings?.certificateLogoUrl
    ? mediaUrl(settings.certificateLogoUrl)
    : null;
  const signatureImg = settings?.certificateSignatureUrl
    ? mediaUrl(settings.certificateSignatureUrl)
    : null;
  const stampImg = settings?.certificateStampUrl
    ? mediaUrl(settings.certificateStampUrl)
    : null;

  return (
    <Main showRightPanel={false} showInfoText={false}>
      <div className="mt-4 font-[Poppins]">
        <AppBreadcrumbs
          items={[
            { label: "Dashboard", to: "/" },
            { label: "Agent Profile" },
            { label: "CSP Certificate" },
          ]}
        />
        <div className="shadow-sm border border-gray-200 rounded-lg p-2 mb-4 mt-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <img
              src={`${userInfo?.logo}`}
              alt="profile"
              className="h-10 w-10 object-cover rounded-md"
            />
            <div className="flex flex-col md:flex-row md:items-center md:gap-2 whitespace-nowrap">
              <p className="text-[13px] md:text-[15px] font-semibold">
                {userInfo?.name || "Guest"}
              </p>
              <p className="hidden md:block text-[18px] font-semibold">|</p>
              <p className="text-[11px] md:text-[15px] font-semibold md:mt-0 mt-[2px]">
                ID: {userInfo?.userName || "N/A"}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate(-1)}
              className="bg-[color-mix(in_srgb,var(--primary-color)_15%,transparent)] make-text-primary px-4 py-2 rounded-md text-xs font-semibold transition whitespace-nowrap flex items-center gap-2"
            >
              <PersonRoundedIcon fontSize="small" />
              <span className="hidden md:inline">Back To Profile</span>
            </button>
            <button
              onClick={() => window.print()}
              className="bg-[color-mix(in_srgb,var(--primary-color)_15%,transparent)] make-text-primary px-4 py-2 rounded-md text-xs font-semibold transition whitespace-nowrap flex items-center gap-2"
            >
              <PrintRoundedIcon fontSize="small" />
              <span className="hidden md:inline">Print</span>
            </button>
          </div>
        </div>
        <div className="print-area shadow-sm border border-gray-300 rounded-lg p-6 mt-4 flex justify-center">
          <div className="w-full max-w-3xl border-[3px] border-[#E3B22A] p-8 text-center relative">
            {certLogo ? (
              <img
                src={certLogo}
                alt={companyName}
                className="h-16 object-contain m-auto"
              />
            ) : (
              <BrandLogo variant="blue" size="lg" className="m-auto" />
            )}
            <p className="text-[#C19500] text-lg font-semibold mt-4">
              Certificate of Authorization
            </p>
            <p className="text-[#C19500] text-lg font-semibold -mt-1">
              CSP Point
            </p>
            <p className="mt-6 font-medium ">This is to Certify that</p>
            <p className="text-lg font-bold text-[#D09C00] mt-2 tracking-wide">
              {userInfo?.name}
            </p>
            <div className="border-t border-gray-300 my-6"></div>
            <p className="make-text-primary font-semibold text-sm">
              Is Appointed as the{" "}
              <span className="uppercase">{userInfo?.role}</span> of{" "}
              {companyName}
            </p>
            <p className=" text-sm mt-3">
              {userInfo?.kycIdId?.address || "-"}
            </p>
            <div className="border-t border-gray-300 my-6"></div>
            <div className="grid grid-cols-3 text-sm mt-6 items-end">
              <div>
                <p className="font-semibold">
                  {formatDate(userInfo?.createdAt || new Date(), "date")}
                </p>
                <p className="text-xs mt-1">Issued Date</p>
              </div>
              <div>
                <p className="font-semibold">{userInfo?.userName || "-"}</p>
                <p className="text-xs mt-1">CSP Code</p>
              </div>
              <div className="flex flex-col items-center">
                {stampImg ? (
                  <img
                    src={stampImg}
                    alt="Stamp"
                    className="h-14 object-contain mb-1 opacity-90"
                  />
                ) : null}
                {signatureImg ? (
                  <img
                    src={signatureImg}
                    alt="Signature"
                    className="h-10 object-contain mb-1"
                  />
                ) : (
                  <p className="font-semibold italic">
                    {settings?.authorizedSignatoryName || "Authorized Signatory"}
                  </p>
                )}
                <p className="text-xs mt-1">Authorized Signature</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Main>
  );
};
export default Certificate;
